import {useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import Footer from "./layout/Footer";
import Navbar from "./layout/Navbar";
import Main from "./layout/Main";
import {Spinner} from "react-bootstrap";

const App = () => {
    const location = useLocation()
    const navigate = useNavigate();
    const [pageLoaded, setPageLoaded] = useState(false);
    setTimeout(() => setPageLoaded(true), 500);
    useEffect(() => {
        if (location.pathname === '/') {
            navigate('/booking');
        }
    }, [location, navigate]);

    return (
        <>
            <Spinner className={'main-spinner'}
                     style={{opacity: +!pageLoaded}}/>
            <div className={'app'} style={{opacity: +pageLoaded}}>
                <Navbar pageLoaded={pageLoaded}/>
                <Main pageLoaded={pageLoaded}>
                    <Outlet/>
                </Main>
                <Footer pageLoaded={pageLoaded}/>
            </div>
        </>
    );
}

export default App;